
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [{
label: '全称',
value: this.$route.params.Item.PTM_Name
}, {
label: '代码说明',
value: this.$route.params.Item.PTM_Remark
}]
}
}



// WEBPACK FOOTER //
// ./src/components/TransactionMethodDetail.vue